import {
  ServiceLevelShippingMarginOverTimeRequestSchema,
  ServiceLevelShippingMarginOverTimeResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getServiceLevelShippingMarginOverTime = {
  name: "getServiceLevelShippingMarginOverTime" as const,
  input: ServiceLevelShippingMarginOverTimeRequestSchema,
  output: ServiceLevelShippingMarginOverTimeResponseSchema,
};
